<!-- <div class="scrollable-y m-15 manage-apps-page"> -->
<div class="row">
  <div class="col-md-12">
    <div>
      <h2>Resources Library</h2>
      <p>
        Resources are also links that can be added to the Links panel in your client portal.  You can add resources from either The Client Hub Library (whch already includes links to training resources for Client Hub and other popular small business apps) or from your Firm Library, where you can add other Resources that you would like to add to client portals. 
        <span class="mt-2 d-block">
          Good examples of Resources that you may want to add your Firm Library below are forms that your clients would access such as: a New Employee form.
        </span>
      </p>
    </div>
    <div>
      <div>
        <div class="manage-resources-list">
          <div class="row">
            <div class="col-12">
              <div style="display: inline-block">
                <span>
                  <!-- <h4 class="manage-apps-filter"><span class="library-name">{{current_library.name}}</span> <i class="feather chevron-down"></i></h4> -->
                  <h4 class="manage-apps-filter" style="cursor: default">
                    <span class="library-name">Available Resources</span>
                    <!--<i class="feather chevron-down"></i>-->
                  </h4>
                </span>
                <!-- <ul *dropdownMenu class="dropdown-menu" role="menu" style="left:15px;top:30px">
                                          <li role="menuitem" (click)="change_library('global')"><a class="dropdown-item">Global Library</a></li>
                                          <li role="menuitem" (click)="change_library('practice')"><a class="dropdown-item">Practice Library</a></li>
                                      </ul> -->
              </div>
              <div class="manage-apps-search">
                <i class="feather search"></i>
                <input type="text" [(ngModel)]="search" placeholder="Search in Resources" />
              </div>
            </div>
          </div>
          <p *ngIf="current_library.name == 'Global Library'">
            Click on a resource to view it.
          </p>
          <p *ngIf="current_library.name == 'Practice Library'">
            Click on a resource to edit details.
          </p>

          <nav class="default-tabs tabs">
            <div class="tabs-wrapper" style="padding-left: 0">
              <a [ngClass]="{
                    active: current_library.name == 'Practice Library'
                  }" (click)="change_library('practice')">Firm Library</a>
              <a [ngClass]="{ active: current_library.name == 'Global Library' }"
                (click)="change_library('global')">Client Hub Library</a>
            </div>
          </nav>

          <div class="row not-selected-resources-list manage-resources-list scrollbars">
            <div class="col-md-4" *ngIf="current_library.name == 'Practice Library'">
              <a href="javascript:" (click)="openResourceModal(resource, true)"
                class="resources-item resources-item-add">
                <div class="resources-thumb">
                  <i class="feather plus x3" style="
                        margin-left: 14px;
                        margin-top: 9px;
                        display: inline-block;
                        color: #485364 !important;
                      "></i>
                </div>
                <div class="resources-content">
                  <div class="resources-content-wrapper">
                    <div class="resources-type">&nbsp;</div>
                    <div class="resources-title" style="top: 12px">
                      New Resource
                    </div>
                    <div class="resources-description" style="padding-top: 3px">
                      Click to add a new resource
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-4" *ngFor="
                  let resource of current_library.bucket
                    | resourceSearch : search;
                  let i = index
                " (click)="
                  current_library.name == 'Practice Library'
                    ? openResourceModal(resource, false)
                    : return
                ">
              <a class="resources-item" [href]="resource.file ? resource.file?.url : resource.url"
                (click)="link ? '' : $event.preventDefault()" target="_blank" rel="noreferrer noopener" filePreview
                [type]="resource.file?.ext" [item]="" [disabledButtons]="['delete', 'move', 'rename']"
                [etag]="resource.file?.etag" [file]="resource.file" [prevent]="
                resource.company !== null &&
                link &&
                (resource.file_type == 1 ||
                  resource.file_type == 2 ||
                  resource.file_type == 4)
              " [resourceId]="resource.id">
                <div class="resources-thumb">
                  <div class="resources-type text-center">
                    <i class="feather" [ngClass]="{
                      'external-link': resource.file_type == 5,
                      image: resource.file_type == 4,
                      play: resource.file_type == 3,
                      'file-text': resource.file_type == 1 || resource.file_type == 2
                    }" [attr.title]="resource.file_type == 5 ? 'External link' : null"
                      [attr.title]="resource.file_type == 4 ? 'Image' : null"
                      [attr.title]="resource.file_type == 3 ? 'Video' : null" [attr.title]="
                      resource.file_type == 1 || resource.file_type == 2 ? 'Document' : null
                    "></i>
                  </div>
                </div>
                <div class="resources-content">
                  <div class="resources-content-wrapper">
                    <div class="resources-title">{{ resource.name }}</div>
                    <div class="resources-description">{{ resource.description }}</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->